export default __webpack_public_path__ + "static/media/eye_off_icon_purple.6a656e7d.svg";